import gql from "graphql-tag";

export const COMPLETE_WEPA_SERVICE_ORDER = gql`
  mutation CompleteWepaServiceOrder($id: ID!) {
    completeWepaServiceOrder(wepaServiceId: $id) {
      feedback
    }
  }
`;
